import React from 'react';
import { LOCAL_COLORS } from 'styles/constants';

import { type IngredientsPopProps } from '../IngredientsPop';
import {
  ACNE_INGREDIENTS,
  POP_INGREDIENTS,
  CHIA_INGREDIENTS,
} from './ingredients-info';

const ingredientTanBG = '#f6f5ec';

export const POP_REDESIGN_INGREDIENTS_CONTENT: IngredientsPopProps = {
  header: 'Get to know our clinically proven ingredients.',
  body: "Our Licensed Dermatology Providers select 3 clinically proven ingredients* that work together to get you closer to the results you're looking for. Commonly used ingredients include:",
  ingredients: POP_INGREDIENTS,
  ctaButton: {
    buttonText: 'Find my custom combination',
  },
  disclaimerText:
    '*Product offer and active ingredients are subject to consultation and determined by your dermatology provider on a person-by-person basis. Subscription required.',
  backgroundColor: ingredientTanBG,
};

export const CHIA_INGREDIENTS_CONTENT: IngredientsPopProps = {
  header: 'Gold standard ingredients ',
  body: /* html */ `
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
      >
        <g clipPath="url(#clip0_714_931)">
          <circle cx="8" cy="8.92578" r="5" fill="white" />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8 16.9258C12.4183 16.9258 16 13.3441 16 8.92578C16 4.5075 12.4183 0.925781 8 0.925781C3.58172 0.925781 0 4.5075 0 8.92578C0 13.3441 3.58172 16.9258 8 16.9258ZM7.70711 11.6329L12.2071 7.13289L10.7929 5.71867L7 9.51157L5.20711 7.71867L3.79289 9.13289L6.29289 11.6329C6.68342 12.0234 7.31658 12.0234 7.70711 11.6329Z"
            fill="#FF824F"
          />
        </g>
        <defs>
          <clipPath id="clip0_714_931">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(0 0.925781)"
            />
          </clipPath>
        </defs>
      </svg>
      <p>
        A combination of <span className={'gold'}>3 active ingredients</span>,
        at the right strengths for your goals
      </p>`,
  ingredients: CHIA_INGREDIENTS,
  ctaButton: {
    buttonText: 'Find your custom combination',
  },
  disclaimerText:
    '*Product offer and active ingredients are subject to consultation and determined by your dermatology provider on a person-by-person basis. Subscription required.',
  backgroundColor: LOCAL_COLORS.surfaceDarkBold,
};

export const ACNE_INGREDIENTS_CONTENT: IngredientsPopProps = {
  header: 'Get to know our clinically proven ingredients.',
  body: "Our Licensed Dermatology Providers select 3 acne-busting ingredients that work together to get you closer to the results you're looking for. Commonly used ingredients include:",
  ingredients: ACNE_INGREDIENTS,
  ctaButton: {
    buttonText: 'Find my custom combination',
  },
  disclaimerText: (
    <React.Fragment>
      *Product offer and active ingredients are subject to consultation and
      determined by your dermatology provider on a person-by-person basis.
      Inform your medical provider about pregnancy status. Subscription
      required.
      <br />
      <br />
      *Spironolactone, which disrupts male hormones, should only be prescribed
      to females.
    </React.Fragment>
  ),
  backgroundColor: ingredientTanBG,
};
